/* rb-m-qa.js -- quick-add for denim FIT PARENTS, phone only. 2026-09-22.
   Needs window.RBM (rb-m-core.js) and the theme's rb-quick-add-sheet.js.

   WHY. A fit parent (Zach, Graduate, Fit 4 Straight ...) has one variant per
   wash -- 21 on Zach -- and the sizes live on the child product for that
   wash. The theme's mobile quick-add sheet (rb-quick-add-sheet.js) already
   handles the size step perfectly: it reads the tile's compact variant map
   (.js-quick-add-variants, children included), filters to the tile's
   CURRENT colour, and adds through the tile's own form so the drawer, GA4,
   final-sale and back-in-stock all work unchanged. What it cannot do is let
   you CHOOSE the wash: on a phone that was 21 unlabelled 24px swatches.

   So this module puts ONE step in front of it, and only on parent cards:

     bag icon on a .rbm-parent
       -> wash sheet: swatch, name, from-price, sold-out state, sorted light
          to dark (luminance of the swatch hex -- the same order as the
          parent's wash_lightness_map), the card's current wash marked
       -> tap a wash: the card's own swatch for that wash is clicked (the
          theme's quick-add-overlay.js updates data-current-color, the tile
          image and the price), then the bag icon is re-fired with a pass
          flag so the theme's size sheet opens for THAT wash
       -> sizes, Add, drawer: theme code, untouched.

   The intercept is a window-level capture listener: it runs before the
   theme's document-level one, so for parent cards the theme never sees the
   first tap. Non-parent cards are not touched. */
(function () {
  'use strict';
  if (!window.RBM) return;

  var PASS = 'data-rbm-pass';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  /* swatch <li title> carries " -- sold out" on unavailable washes */
  function washName(li) {
    var t = li.getAttribute('title') || '';
    var vs = li.querySelector('variant-swatch');
    if (!t && vs) t = vs.getAttribute('aria-label') || '';
    return t.replace(/\s+[\u2014\u2013-]+\s*sold\s*out\s*$/i, '').trim();
  }
  function lum(hex) {
    var m = String(hex || '').trim().match(/^#?([0-9a-f]{6})$/i);
    if (!m) return 50;
    var n = parseInt(m[1], 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  /* What is actually in stock for a wash, as one line under its name (Mark,
     22 Sep: "I wouldn't want someone disappointed selecting a wash expecting
     it to be filled out"). Denim (NNxNN) lists the WAISTS that have any length
     in stock -- the question a shopper is asking is "is my 33 there", and a
     short line reads as thin stock without a colour bar. Three sizes or fewer
     spells them out in the sale colour. Alpha sizes list the sizes. */
  function sizeLine(sizes, total) {
    if (!sizes || !sizes.length) return '';
    var denim = sizes.every(function (x) { return /^\d{2}\s*x\s*\d{2}$/i.test(x); });
    if (sizes.length <= 3 && (total == null || total > 3)) {
      return '<span class="rbm-wash__sizes is-low">Only ' + sizes.length + ' left \u00b7 ' + esc(sizes.join(', ')) + '</span>';
    }
    if (denim) {
      var waists = []; sizes.forEach(function (x) { var w = x.split(/x/i)[0].trim(); if (waists.indexOf(w) < 0) waists.push(w); });
      waists.sort(function (a, b) { return a - b; });
      return '<span class="rbm-wash__sizes"><i>Waist</i> ' + waists.join(' \u00b7 ') + '</span>';
    }
    return '<span class="rbm-wash__sizes">' + esc(sizes.join(' \u00b7 ')) + '</span>';
  }

  /* One row per wash from the tile's own data: name + hex + image from the
     swatch list, availability + lowest price from the variant map. */
  function washes(card) {
    var node = card.querySelector('.js-quick-add-variants');
    var map = [];
    try { map = JSON.parse(node.textContent) || []; } catch (e) { return []; }
    var byColor = {};
    map.forEach(function (r) {
      var c = r[1] || ''; if (!c) return;
      var w = byColor[c] || (byColor[c] = { name: c, avail: 0, n: 0, price: null, sizes: [] });
      w.n++; if (r[3]) { w.avail++; if (r[2]) w.sizes.push(String(r[2])); }
      var p = parseInt(r[6], 10);
      if (!isNaN(p) && (w.price == null || p < w.price)) w.price = p;
    });
    /* light -> dark by the parent's own wash_lightness_map metafield (on the
       card as data-rb-wash-lightness); swatch-hex luminance is the fallback */
    var light = {};
    try { light = JSON.parse(card.getAttribute('data-rb-wash-lightness') || '{}') || {}; } catch (e) { light = {}; }
    var out = [];
    Array.prototype.forEach.call(card.querySelectorAll('.js-product-swatch-item'), function (li) {
      var name = washName(li);
      var w = byColor[name]; if (!w) return;
      var vs = li.querySelector('variant-swatch');
      var style = (vs && vs.getAttribute('style')) || '';
      var hex = (style.match(/--background-graphic:\s*(#[0-9a-f]{3,8})/i) || [])[1] || '';
      var L = light[name];
      out.push({ name: name, hex: hex, avail: w.avail, n: w.n, sizes: w.sizes, price: w.price, li: li, light: (typeof L === 'number' ? L : lum(hex) / 2.55) });
    });
    out.sort(function (a, b) { return b.light - a.light; });   /* light -> dark */
    return out;
  }

  var sheet = null;
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'rbm-sheet rbm-wash';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-label', 'Choose a wash');
    sheet.innerHTML =
      '<div class="rbm-sheet__grab"></div>' +
      '<div class="rbm-sheet__head rbm-wash__head">' +
        '<img class="rbm-wash__img" alt="">' +
        '<div class="rbm-wash__titles"><b class="rbm-wash__title"></b><span class="rbm-wash__sub">Choose a wash</span></div>' +
        '<button type="button" class="rbm-wash__close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="rbm-sheet__body rbm-wash__list"></div>';
    document.body.appendChild(sheet);
    sheet.querySelector('.rbm-wash__close').addEventListener('click', RBM.closeSheet);
    sheet.querySelector('.rbm-wash__list').addEventListener('click', function (e) {
      var row = e.target.closest('.rbm-wash__row');
      if (!row || !sheet._card) return;
      pick(sheet._card, row.getAttribute('data-wash'));
    });
    return sheet;
  }

  function open(card) {
    var rows = washes(card);
    if (rows.length < 2) return false;           /* one wash: theme sheet is fine */
    var s = ensureSheet();
    s._card = card;
    var ov = card.querySelector('.js-quick-add-overlay');
    var cur = ov ? ov.dataset.currentColor : '';
    s.querySelector('.rbm-wash__title').textContent = card.dataset.ga4ItemName || '';
    var img = card.querySelector('img');
    var im = s.querySelector('.rbm-wash__img');
    if (img && (img.currentSrc || img.src)) { im.src = img.currentSrc || img.src; im.hidden = false; } else im.hidden = true;
    s.querySelector('.rbm-wash__sub').textContent = rows.length + ' washes · choose one, then your size';
    s.querySelector('.rbm-wash__list').innerHTML = rows.map(function (w) {
      var out = !w.avail;
      return '<button type="button" class="rbm-wash__row' + (out ? ' is-out' : '') + (w.name === cur ? ' is-cur' : '') + '" data-wash="' + esc(w.name) + '">' +
        '<span class="rbm-wash__sw" style="background:' + esc(w.hex || '#ddd') + '"></span>' +
        '<span class="rbm-wash__name"><span class="rbm-wash__nm">' + esc(w.name) + '</span>' + (out ? '' : sizeLine(w.sizes, w.n)) + '</span>' +
        '<span class="rbm-wash__meta">' + (out ? 'Sold out' : money(w.price)) + '</span>' +
      '</button>';
    }).join('');
    RBM.openSheet(s);
    return true;
  }

  /* Select the wash on the card (theme updates image, price, current colour),
     then re-fire the bag icon with a pass flag so the theme's size sheet
     opens for that wash. */
  function pick(card, name) {
    var li = Array.prototype.find.call(card.querySelectorAll('.js-product-swatch-item'), function (x) { return washName(x) === name; });
    var ov = card.querySelector('.js-quick-add-overlay');
    /* the theme's ProductCardSwatches listens on the <li> and reads ITS
       data-variant-image; clicking the inner input threw in updateCardImage */
    if (li) li.click();
    if (ov) ov.dataset.currentColor = name;   /* belt and braces if the swatch handler is async */
    RBM.closeSheet();
    var trig = card.querySelector('.js-quick-add-mobile-trigger');
    if (!trig) return;
    var row = washes(card).filter(function (w) { return w.name === name; })[0];
    setTimeout(function () {
      trig.setAttribute(PASS, '1');
      trig.click();
      trig.removeAttribute(PASS);
      /* The theme's size sheet reads the card for its header; the card's image
         is mid-swap at that moment and it only knows the parent's name and
         price. Fill in the wash: "Zach" -> "Zach - Dark Faded Classic Blue",
         the wash's from-price, and the wash's own photo. */
      var qas = document.querySelector('.rb-qas');
      if (!qas) return;
      var t = qas.querySelector('.js-rb-qas-title');
      var pr = qas.querySelector('.js-rb-qas-price');
      var im = qas.querySelector('.js-rb-qas-img');
      if (t && t.textContent.indexOf(name) < 0) t.textContent = t.textContent.replace(/\s*$/, '') + ' \u2014 ' + name;
      if (pr && row && row.price != null) pr.textContent = money(row.price);
      var img = li && li.getAttribute('data-variant-image');
      if (im && img) { im.src = img.replace('{width}', '240'); im.hidden = false; }
    }, 320);   /* after the sheet's close transition so two sheets never overlap */
  }

  /* On fit cards the swatch strip is hidden (CSS); this row replaces it:
     three tone dots (lightest, middle, darkest) + "21 washes", opening the
     same sheet. Re-run on section swaps so filtered grids get it too. */
  function washRows(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.rbm-parent'), function (card) {
      if (card.querySelector('.rbm-washes')) return;
      var rows = washes(card);
      if (rows.length < 2) return;
      var anchor = card.querySelector('.swatch-wrapper') || card.querySelector('.product-card__details');
      if (!anchor) return;
      var pick3 = [rows[0], rows[Math.floor(rows.length / 2)], rows[rows.length - 1]];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rbm-washes';
      btn.innerHTML = '<span class="rbm-washes__dots">' + pick3.map(function (w) { return '<i style="background:' + esc(w.hex || '#ccc') + '"></i>'; }).join('') + '</span>' + rows.length + ' washes';
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(card); });
      anchor.parentNode.insertBefore(btn, anchor);
    });
  }

  /* ---- the PDP wash picker (22 Sep sweep) ------------------------------------
     On a fit parent's own page the theme renders every wash as a 74x92 photo
     tile with name and price: 21 tiles in five columns, 753px, 11px labels
     wrapping to three lines. The same idea as the card quick-add: ONE row --
     current wash photo, name, "21 washes" -- that opens a sheet listing every
     wash (photo, name, price, sold out), lightest to darkest. Tapping a wash
     clicks the theme's own radio label, so the theme does what it always did
     (on this store: navigates to that wash's child product).

     Light-to-dark order comes from the product's wash_lightness_map, which
     rb-m-include.liquid now prints as JSON (#rbm-wash-lightness) on product
     pages. If it is missing the theme's order is kept. */
  RBM.onMobile('pdp-wash', function () {
    var fs = document.querySelector('fieldset.wash-tiles');
    if (!fs || fs.dataset.rbmWash) return;
    var tiles = Array.prototype.slice.call(fs.querySelectorAll('.wash-tiles__tile'));
    if (tiles.length < 2) return;
    fs.dataset.rbmWash = '1';

    var light = {};
    try { light = JSON.parse((document.getElementById('rbm-wash-lightness') || {}).textContent || '{}') || {}; } catch (e) { light = {}; }

    function rows() {
      return tiles.map(function (l, i) {
        var input = document.getElementById(l.getAttribute('for') || '');
        var name = (l.querySelector('.wash-tiles__name') || {}).textContent || '';
        var img = l.querySelector('img');
        var L = light[name.trim()];
        return {
          label: l, name: name.trim(),
          price: ((l.querySelector('.wash-tiles__price') || {}).textContent || '').trim(),
          img: img ? (img.getAttribute('src') || '') : '',
          out: /sold|unavail|disabled/i.test(l.className + ' ' + (l.parentElement ? l.parentElement.className : '')) || (input && input.disabled),
          cur: !!(input && input.checked),
          light: typeof L === 'number' ? L : (1000 - i)   /* no map: keep theme order */
        };
      }).sort(function (a, b) { return b.light - a.light; });
    }

    /* Per-wash stock comes from each wash's own product (the radios carry
       data-product-url): one small .js fetch per wash, on first open, cached. */
    var stock = {};
    function loadStock(done) {
      var pending = 0;
      tiles.forEach(function (l) {
        var name = ((l.querySelector('.wash-tiles__name') || {}).textContent || '').trim();
        if (stock[name]) return;
        var input = document.getElementById(l.getAttribute('for') || '');
        var url = input && input.getAttribute('data-product-url');
        if (!url) return;
        stock[name] = { sizes: null, n: 0 };
        pending++;
        fetch(url.split('?')[0] + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
          if (j && j.variants) {
            var opts = j.options || [];
            var sIdx = opts.length ? opts.length - 1 : 0;   /* size is the last option on this store */
            var sizes = [];
            j.variants.forEach(function (v) { if (v.available) { var sz = v['option' + (sIdx + 1)] || (v.options || [])[sIdx]; if (sz) sizes.push(String(sz)); } });
            stock[name] = { sizes: sizes, n: j.variants.length };
          }
        }).catch(function () {}).then(function () { if (--pending === 0) done(); });
      });
      if (!pending) done();
    }
    function paintStock() {
      if (!sheet) return;
      Array.prototype.forEach.call(sheet.querySelectorAll('.rbm-wash__row'), function (b) {
        var st = stock[b.getAttribute('data-wash')]; var slot = b.querySelector('.rbm-wash__sizes-slot');
        if (!st || !slot) return;
        if (st.sizes === null) return;
        if (!st.sizes.length) { b.classList.add('is-out'); b.querySelector('.rbm-wash__meta').textContent = 'Sold out'; slot.innerHTML = ''; return; }
        slot.innerHTML = sizeLine(st.sizes, st.n);
      });
    }

    var row = document.createElement('button');
    row.type = 'button';
    row.className = 'rbm-pdpwash';
    function paint() {
      var rs = rows(); var cur = rs.filter(function (r) { return r.cur; })[0] || rs[0];
      row.innerHTML = '<img class="rbm-pdpwash__img" alt="" src="' + esc(cur.img) + '">' +
        '<span class="rbm-pdpwash__txt"><span class="rbm-pdpwash__k">Wash</span><b class="rbm-pdpwash__v">' + esc(cur.name) + '</b></span>' +
        '<span class="rbm-pdpwash__n">' + rs.length + ' washes <i aria-hidden="true">&#8250;</i></span>';
    }
    paint();
    fs.parentNode.insertBefore(row, fs.nextSibling);
    fs.classList.add('rbm-pdpwash-src');

    var sheet;
    row.addEventListener('click', function () {
      if (!sheet) {
        sheet = document.createElement('div');
        sheet.className = 'rbm-sheet rbm-wash rbm-wash--pdp';
        sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-label', 'Choose a wash');
        sheet.innerHTML = '<div class="rbm-sheet__grab"></div>' +
          '<div class="rbm-sheet__head rbm-wash__head"><div class="rbm-wash__titles"><b class="rbm-wash__title">Choose a wash</b><span class="rbm-wash__sub"></span></div>' +
          '<button type="button" class="rbm-wash__close" aria-label="Close">&times;</button></div>' +
          '<div class="rbm-sheet__body rbm-wash__list"></div>';
        document.body.appendChild(sheet);
        sheet.querySelector('.rbm-wash__close').addEventListener('click', RBM.closeSheet);
        sheet.querySelector('.rbm-wash__list').addEventListener('click', function (e) {
          var b = e.target.closest('.rbm-wash__row'); if (!b) return;
          var name = b.getAttribute('data-wash');
          var hit = tiles.filter(function (l) { return ((l.querySelector('.wash-tiles__name') || {}).textContent || '').trim() === name; })[0];
          RBM.closeSheet();
          if (hit) { hit.click(); setTimeout(paint, 50); }
        });
      }
      var rs = rows();
      sheet.querySelector('.rbm-wash__sub').textContent = rs.length + ' washes · lightest to darkest';
      sheet.querySelector('.rbm-wash__list').innerHTML = rs.map(function (r) {
        return '<button type="button" class="rbm-wash__row' + (r.out ? ' is-out' : '') + (r.cur ? ' is-cur' : '') + '" data-wash="' + esc(r.name) + '">' +
          '<img class="rbm-wash__photo" alt="" loading="lazy" src="' + esc(r.img) + '">' +
          '<span class="rbm-wash__name"><span class="rbm-wash__nm">' + esc(r.name) + '</span><span class="rbm-wash__sizes-slot">' + (r.out ? '' : '<span class="rbm-wash__sizes is-wait">&hellip;</span>') + '</span></span>' +
          '<span class="rbm-wash__meta">' + (r.out ? 'Sold out' : esc(r.price.replace(/\.00$/, ''))) + '</span></button>';
      }).join('');
      RBM.openSheet(sheet);
      paintStock();
      loadStock(paintStock);
    });
  });

  /* ---- the theme's size sheet, for denim: waist -> inseam ---------------------
     rb-quick-add-sheet.js lists every size of the chosen wash as a row
     ("32x30  Add", "33x30  Sold out -- notify me"): ten rows, a scroll, for
     what is really "your waist, then your length". When every row is NNxNN
     a Waist chip row is put above the list and the rows are filtered to the
     tapped waist. The rows themselves stay the theme's -- Add and Notify me
     are untouched. Re-applied every time the sheet re-renders its list. */
  RBM.onMobile('qa-denim-sheet', function () {
    function apply(list) {
      /* sold-out rows to the bottom (Mark, 29 Sep) -- before the waist logic */
      var all = Array.prototype.slice.call(list.querySelectorAll('.rb-qas__row'));
      if (all.length && all.every(function (r) { return r.parentNode === all[0].parentNode; })) {
        sortSoldOut(all[0].parentNode, all,
          function (r) { return r.classList.contains('rb-qas__row--out'); },
          function (r) { return (r.querySelector('.rb-qas__row-size') || r).textContent; });
      }
      var rows = Array.prototype.slice.call(list.querySelectorAll('.rb-qas__row'));
      var sizes = rows.map(function (r) { return ((r.querySelector('.rb-qas__row-size') || {}).textContent || '').trim(); });
      var qas = list.closest('.rb-qas');
      var old = qas && qas.querySelector('.rbm-qsw');
      var denim = rows.length >= 4 && sizes.every(function (s) { return /^\d{2}\s*x\s*\d{2}$/i.test(s); });
      if (!denim) { if (old) old.parentNode.removeChild(old); list.classList.remove('rbm-qsw-on'); rows.forEach(function (r) { r.hidden = false; }); return; }
      var waists = []; var okBy = {};
      rows.forEach(function (r, i) { var w = sizes[i].split(/x/i)[0].trim(); if (waists.indexOf(w) < 0) waists.push(w); if (!r.classList.contains('rb-qas__row--out')) okBy[w] = true; r.setAttribute('data-rbm-w', w); });
      waists.sort(function (a, b) { return a - b; });
      var cur = list.getAttribute('data-rbm-w') || '';
      if (cur && waists.indexOf(cur) < 0) cur = '';
      var box = old || document.createElement('div');
      box.className = 'rbm-qsw';
      box.innerHTML = '<div class="rbm-qsw__lab">Waist</div><div class="rbm-qsw__row">' + waists.map(function (w) {
        return '<button type="button" class="rbm-qsw__chip' + (w === cur ? ' is-on' : '') + (okBy[w] ? '' : ' is-out') + '" data-w="' + w + '">' + w + '</button>';
      }).join('') + '</div><div class="rbm-qsw__lab">' + (cur ? 'Inseam' : 'Inseam <span>pick a waist first</span>') + '</div>';
      if (!old) list.parentNode.insertBefore(box, list);
      list.classList.add('rbm-qsw-on');
      list.setAttribute('data-rbm-w', cur);
      rows.forEach(function (r) { r.hidden = !cur || r.getAttribute('data-rbm-w') !== cur; });
      var lab = qas && qas.querySelector('.js-rb-qas-label');
      if (lab && /select size/i.test(lab.textContent)) lab.textContent = 'Select size';
    }
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.rbm-qsw__chip'); if (!chip) return;
      var list = chip.closest('.rb-qas').querySelector('.js-rb-qas-list');
      list.setAttribute('data-rbm-w', chip.getAttribute('data-w'));
      apply(list);
    });
    function watch() {
      Array.prototype.forEach.call(document.querySelectorAll('.js-rb-qas-list'), function (list) {
        if (list.dataset.rbmWatched) return;
        list.dataset.rbmWatched = '1';
        var ob = new MutationObserver(RBM.debounce(function () { list.removeAttribute('data-rbm-w'); apply(list); }, 30));
        ob.observe(list, { childList: true });
        apply(list);
      });
    }
    watch();
    if (window.MutationObserver) new MutationObserver(RBM.debounce(watch, 100)).observe(document.body, { childList: true });
  });

  /* ---- sold-out sizes to the bottom of quick-add (Mark, 29 Sep) ---------------
     In-stock sizes first, sold-out after; each group in natural size order
     (denim NNxNN by waist then inseam, numbers numerically, alpha S-M-L...).
     The theme's variant order is per-child and came out as 31x32, 32x30 ...
     38x32, 30x32 -- so this also puts 30 before 31. Only reorders nodes; the
     theme's handlers, values and Notify-me rows are untouched. Returns true if
     it moved anything, so callers watching the list can ignore their own
     mutation. */
  var ALPHA = { xxs: 0, xs: 1, 'x-small': 1, s: 2, small: 2, m: 3, medium: 3, l: 4, large: 4, xl: 5, 'x-large': 5, xxl: 6, 'xx-large': 6, '2xl': 6, xxxl: 7, 'xxx-large': 7, '3xl': 7 };
  function sizeKey(label) {
    var t = String(label || '').replace(/\s*[—–-]+\s*sold\s*out.*$/i, '').replace(/\s*notify.*$/i, '').trim().toLowerCase().replace(/\s+/g, '');
    var m = t.match(/^(\d{2})x(\d{2})$/); if (m) return [0, +m[1], +m[2]];
    if (/^\d+(\.\d+)?$/.test(t)) return [1, parseFloat(t), 0];
    if (t in ALPHA) return [2, ALPHA[t], 0];
    return [3, 0, 0];   /* unknown labels keep their original order (stable sort) */
  }
  function sortSoldOut(parent, items, isOut, labelOf) {
    if (!parent || items.length < 2) return false;
    var idx = items.map(function (el, i) { return { el: el, i: i, out: isOut(el) ? 1 : 0, k: sizeKey(labelOf(el)) }; });
    var sorted = idx.slice().sort(function (a, b) {
      return a.out - b.out || a.k[0] - b.k[0] || a.k[1] - b.k[1] || a.k[2] - b.k[2] || a.i - b.i;
    });
    if (sorted.every(function (x, n) { return x.i === n; })) return false;   /* already in order */
    var anchor = items[items.length - 1].nextSibling;
    sorted.forEach(function (x) { parent.insertBefore(x.el, anchor); });
    return true;
  }

  /* shared with rb-d-pdp.js (desktop quick-add tray shows the same per-wash stock line) */
  RBM.qaShared = { washes: washes, sizeLine: sizeLine, washName: washName, sortSoldOut: sortSoldOut };

  RBM.onMobile('qa-wash', function () {
    washRows();
    var grid = document.querySelector('.collection-products') || document.querySelector('main');
    if (grid && RBM.onSectionSwap) RBM.onSectionSwap(grid, function () { washRows(); });
    if (window.MutationObserver) new MutationObserver(RBM.debounce(function () { washRows(); }, 150)).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('click', function (e) {
      if (!RBM.isMobile()) return;
      var trig = e.target.closest && e.target.closest('.js-quick-add-mobile-trigger');
      if (!trig || trig.hasAttribute(PASS)) return;
      var card = trig.closest('.rbm-parent');
      if (!card) return;
      if (open(card)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });
})();
